module.exports = __webpack_public_path__ + "img/icon-progress-empty.09220720.png";